<template>
    <div class="members-change-password">
        <BackButton
                defaultRoute="/members/dashboard"
                containerClass="studio__btn"
        />

        <form
            @submit.prevent="changePasswordHandler"
            class="members-change-password-form"
        >
            <div class="form-row">
                <div class="form__row-title ">
                    * {{ $t("members.change-password.current_password") }}
                </div>
                <div class="form__row-field is-password">
                    <textField
                            v-model.trim="current_password"
                            :v="$v.current_password"
                            :placeholder="$t('members.change-password.current_password')"
                            type="password"
                            theme="light"
                    />
                </div>
            </div>


            <div class="form-row">
                <div class="form__row-title ">
                    * {{ $t("members.change-password.new_password") }}
                </div>
                <div class="form__row-field is-password">
                    <textField
                            v-model.trim="new_password"
                            :v="$v.new_password"
                            :placeholder="$t('members.change-password.new_password')"
                            type="password"
                            theme="light"
                    />
                </div>
            </div>

            <div class="form-row">
                <div class="form__row-title ">
                    * {{ $t("members.change-password.password_confirmation") }}
                </div>
                <div class="form__row-field is-password">
                    <textField
                            v-model.trim="new_password_confirmation"
                            :v="$v.new_password_confirmation"
                            :placeholder="$t('members.change-password.password_confirmation')"
                            type="password"
                            theme="light"
                    />
                </div>
            </div>

            <button type="submit" class="btn btn-m btn-gradient members-change-password__button">
                <span>{{$t('members.change-password.button')}} </span>
            </button>

            <div class="form__row-title members-change-password__required">
                * {{ $t("members.change-password.required") }}
            </div>
        </form>

    </div>
</template>

<script>
    import { checkPassword } from '../../helpers/validators';
    import { changePassword } from "../../api/clientServices";
    import { required, sameAs } from 'vuelidate/lib/validators';
    import textField from "../../elements/textField";

    export default {
        components: {
            textField,
        },

        data () {
            return {
                current_password: '',
                new_password: '',
                new_password_confirmation: ''
            }
        },

        validations: {
            current_password: {
                required
            },
            new_password: {
                required,
                checkPassword
            },
            new_password_confirmation: {
                required,
                checkPassword,
                sameAs: sameAs('new_password')
            }
        },

        methods: {
            async changePasswordHandler () {
                this.$v.$touch();
                if (this.$v.$invalid) return;

                const {
                    current_password,
                    new_password,
                    new_password_confirmation
                } = this;

                const data = {
                    current_password,
                    new_password,
                    new_password_confirmation
                };

                try {
                    await changePassword(data);

                    await this.$router.push({ name: 'member-dashboard' });

                    await this.$store.dispatch('ADD_ALERT', { type: 'success', text: this.$t('members.change-password.success')})
                } catch (e) {
                    let errors = e.response.data.errors;
                    Object.keys(errors).forEach(key => {
                        this.$store.dispatch('ADD_ALERT', {type: "error", text: errors[key][0]})
                    })
                }

            }
        }
    }
</script>

<style lang="sass" scoped>
.members-change-password
    margin: 0 auto
    width: 850px

    +r(966)
        width: auto
        margin: 0 20px

    &-form
        margin-top: 14px
        display: grid
        grid-template-columns: repeat(2, 1fr)
        column-gap: 95px
        row-gap:  15px

        +r(966)
            column-gap: 30px

        +r(750)
            grid-template-columns: 1fr


    &__button
        margin-top: 30px

        +r(750)
            margin-top: 0

    &__required
        color: rgba($color--dark, 0.6)


    .form__row-title
        color: $color--dark !important
    +r(966)
        .form__row-field
            /*width: 350px*/
</style>